module.exports = __webpack_public_path__ + "static/media/dokia-forgotPassword.61977e44.svg";